/* ════ SUBTASK HELPERS ═════════════════════════════════════ */
import { state } from './state.js';
import { $ } from './dom.js';
import { sb } from './supabase/client.js';
import { setSyncDot } from './supabase/data.js';
import { showToast } from './utils/toast.js';

export function updateStProgress() {
  const done = state.subtasks.filter(s => s.done).length, total = state.subtasks.length;
  $('st-progress').textContent = total > 0 ? `${done}/${total} done` : '';
}

// Auto-tick the task's Complete box when every subtask is done (called on a
// user toggle, not on initial render).
function autoComplete() {
  const c = $('f-complete');
  if (c && state.subtasks.length && state.subtasks.every(s => s.done)) c.checked = true;
}

// Split a subtask out into its own Inbox card, then drop it from the list.
// (From the Inbox you can Schedule it onto the planner.)
async function splitToInbox(arr, i, refresh) {
  const item = arr[i]; if (!item) return;
  setSyncDot('busy');
  const { error } = await sb.from('ideas').insert({
    name: item.text, description: '', cat: 'uncat', importance: 'normal',
    resource: null, days: null, tags: [], subtasks: [],
    created_by: state.currentUser?.email || null,
  });
  if (error) { setSyncDot('err'); showToast('Split failed: ' + error.message); return; }
  setSyncDot('ok'); showToast('Subtask → Inbox ✓ (Save to keep it removed here)');
  arr.splice(i, 1); refresh();
}

function splitBtn(arr, i, refresh) {
  const b = document.createElement('button');
  b.className = 'st-split'; b.type = 'button'; b.title = 'Split into a new Inbox card'; b.innerHTML = '⤴';
  b.onclick = () => splitToInbox(arr, i, refresh);
  return b;
}

// Inline, eval-free binding for the task modal's subtask list.
export function refreshSubtaskUI() {
  const el = $('subtask-list'); el.innerHTML = '';
  state.subtasks.forEach((s, i) => {
    const d = document.createElement('div'); d.className = 'subtask-item';
    const chk = document.createElement('div'); chk.className = 'st-check' + (s.done ? ' done' : '');
    chk.onclick = () => { state.subtasks[i].done = !state.subtasks[i].done; refreshSubtaskUI(); updateStProgress(); autoComplete(); };
    const txt = document.createElement('span'); txt.className = 'st-text' + (s.done ? ' done' : ''); txt.textContent = s.text;
    const del = document.createElement('button'); del.className = 'st-del'; del.innerHTML = '&#215;';
    del.onclick = () => { state.subtasks.splice(i, 1); refreshSubtaskUI(); updateStProgress(); };
    d.append(chk, txt, splitBtn(state.subtasks, i, () => { refreshSubtaskUI(); updateStProgress(); }), del); el.appendChild(d);
  });
  updateStProgress();
}
export function addSubtask() {
  const inp = $('new-subtask'), text = inp.value.trim(); if (!text) return;
  state.subtasks.push({ text, done: false }); inp.value = ''; refreshSubtaskUI();
}

export function refreshIdeaStUI() {
  const el = $('idea-st-list'); el.innerHTML = '';
  state.ideaSubtasks.forEach((s, i) => {
    const d = document.createElement('div'); d.className = 'subtask-item';
    const chk = document.createElement('div'); chk.className = 'st-check' + (s.done ? ' done' : '');
    chk.onclick = () => { state.ideaSubtasks[i].done = !state.ideaSubtasks[i].done; refreshIdeaStUI(); };
    const txt = document.createElement('span'); txt.className = 'st-text' + (s.done ? ' done' : ''); txt.textContent = s.text;
    const del = document.createElement('button'); del.className = 'st-del'; del.innerHTML = '&#215;';
    del.onclick = () => { state.ideaSubtasks.splice(i, 1); refreshIdeaStUI(); };
    d.append(chk, txt, splitBtn(state.ideaSubtasks, i, refreshIdeaStUI), del); el.appendChild(d);
  });
}
export function addIdeaSubtask() {
  const inp = $('idea-new-st'), text = inp.value.trim(); if (!text) return;
  state.ideaSubtasks.push({ text, done: false }); inp.value = ''; refreshIdeaStUI();
}
